/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Recoverywheel1Inputs */



/**
* | output |
* | --- |
* | "Recovery wheel" |
*
* @param {Ahu_History_Key_Recoverywheel1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_recoverywheel1 = /** @type {((inputs?: Ahu_History_Key_Recoverywheel1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Recoverywheel1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recovery wheel")
	return /** @type {LocalizedString} */ ("Roue de récupération")
});
export { ahu_history_key_recoverywheel1 as "ahu_history_key_recoveryWheel" }